export const BreadCrumbsSeparator = () => {
  return (
    <div>
      <svg
        xmlns='https//www.w3.org/2000/svg'
        width='9'
        height='10'
        viewBox='0 0 9 10'
        fill='none'
      >
        <path d='M0 5L8.25 0.23686V9.76314L0 5Z' fill='#50F7FA' />
      </svg>
    </div>
  )
}
